import React, { useState, useEffect, useRef } from "react";
import {
  getUserProfileStatus,
  getSelectedMenu,
  haveAccessToFeature,
  isRoleCashier,
  hideMarketingPage,
} from "../../utils";
import {
  hasAccessUMP,
  PROFILE_STATUS_DRAFT,
  TROY_SIDE_BAR_NAVIGATION,
} from "../../constants";
import createMenus from "./SidebarMenuV2Data";
import { isFunction } from "lodash";
import { Tooltip } from "@duxton-web/ui";

const SidebarMenuV2 = (props) => {
  const {
    handleItemClick,
    overrideSelectedPage,
    collapsed,
    trackTroyAnalytics,
  } = props;

  const shouldShowLabel = () => {
    // implement custom logic here to show or hide the New tag. can pass key as param to check
    return false;
  };

  /* START: marketing tracking */
  const isCashier = isRoleCashier();
  const isUMPNonMexUser =
    haveAccessToFeature(hasAccessUMP) &&
    getUserProfileStatus() === PROFILE_STATUS_DRAFT;

  const [selectedPageInternal, setSelectedPageInternal] =
    useState(getSelectedMenu());
  const trackedMarketingTabRedLabelView = useRef(false);
  useEffect(() => {
    if (
      !collapsed &&
      !isCashier &&
      !hideMarketingPage() &&
      !isUMPNonMexUser &&
      !trackedMarketingTabRedLabelView.current
    ) {
      trackedMarketingTabRedLabelView.current = true;
      trackTroyAnalytics(
        TROY_SIDE_BAR_NAVIGATION,
        "PRODUCT_UPSELL.MARKETING_TAB_RED_LABEL_VIEW",
        null,
      );
    }
  }, [collapsed, isCashier, isUMPNonMexUser, trackTroyAnalytics]);
  /* END: marketing tracking */

  const menus = createMenus(collapsed);

  const selectedPage = overrideSelectedPage || selectedPageInternal;

  const getMenuItem = (menu) => {
    return (
      <li
        className={[
          "sidebar-menu__item",
          selectedPage === menu.key ? "sidebar-menu__item--selected" : "",
        ].join(" ")}
        onClick={() => {
          setSelectedPageInternal(menu.key);
          handleItemClick({ key: menu.key });
        }}
        key={menu.key}
      >
        <div className="menu-item navigation-docs">
          <span data-testid={menu.testId} className="troy-menu-icon">
            {selectedPage === menu.key ? menu.iconSelected : menu.icon}
          </span>
          <span className="sidebar-menu-item-title">{menu.title}</span>
          {shouldShowLabel() && menu.label}
        </div>
      </li>
    );
  };

  return (
    <ul className="sidebar-menu">
      {menus.map((menu) => {
        if (menu.show) {
          return collapsed ? (
            <Tooltip title={menu.title} placement="right">
              {getMenuItem(menu)}
            </Tooltip>
          ) : (
            getMenuItem(menu)
          );
        }
      })}
    </ul>
  );
};

export default SidebarMenuV2;
